var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('nav',{staticClass:"menu__content",class:{'is-open': _vm.showMobileMenu}},[_c('router-view',{attrs:{"name":"menu"}})],1),_vm._v(" "),_c('div',{staticClass:"menu__scrim"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e1fd2e7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/menu/Menu.vue
// module id = 447
// module chunks = 1